import { Scene } from 'dragonmouse-shared/interfaces';
import {
	refreshFramePermissions,
	resolveOptimisticallyUpdatedScenes,
	updateScenes,
} from '../../redux/db/actions';
import store from '../../redux/store';
import { VITE_FORGE_URL } from '../../constants';
import { SceneRow } from '../types';
import { parsePostgresDate } from '../util';
import { Stream } from './Stream';
import { v4 as uuid } from 'uuid';
import { ChangeMessage, isChangeMessage, Message, Row } from '@electric-sql/client';

export class ScenesStream extends Stream<SceneRow> {
	constructor(userId: string) {
		const url = VITE_FORGE_URL + '/electric/scenes';
		const params = {
			userId,
			shapeBust: uuid(),
		};
		const onError = (error: Error) => {
			console.error('Scenes stream error:', error);
			store.dispatch(updateScenes([]));
		};

		super(url, params, onError, 'scenes');
	}

	onShapeData(rows: SceneRow[]) {
		const scenes: Scene[] = rows.map((sceneRow) => ({
			id: sceneRow.id,
			title: sceneRow.title,
			description: sceneRow.description,
			metadata: sceneRow.metadata,
			createdAt: parsePostgresDate(sceneRow.created_at),
			writeId: sceneRow.write_id,
			viewOnly: false, // These are the user's own scenes, so they're editable
		}));
		store.dispatch(updateScenes(scenes));

		// Refresh frame permissions now that scenes are loaded
		// This will update viewOnly flags on existing frames based on the new scenes collection
		store.dispatch(refreshFramePermissions());
	}

	onStreamMessages(messages: Array<unknown>) {
		const writeIds = messages
			.filter((msg): msg is ChangeMessage<SceneRow> => isChangeMessage(msg as Message<Row<never>>))
			.map((message): string => {
				return message.value.write_id || `delete:${message.value.id}`;
			});
		store.dispatch(resolveOptimisticallyUpdatedScenes(writeIds));
	}
}
